<template>
  <div>
    <van-nav-bar
      id="xy-navBar--isTransparent"
      :class="{ 'xy-navBar--isTransparent': style_isTransparent }"
      fixed
    >
      <van-icon name="arrow-left" color="#333" class="icon-title-size" slot="left" @click="onClickLeft" />
      <div slot="title">
        <div style="display: flex;justify-content: center;align-items: center;" v-if="isBreadcrumbIcon || isMsg" @click="showTopBtn">
          <span>{{ titleName }}</span>
          <van-icon name="arrow-down" color="#333" class="icon-left" />
        </div>
        <div v-else>
          <span>{{ titleName }}</span>
        </div>
      </div>
      <van-icon name="weapp-nav" color="#333" class="icon-title-size" slot="right" @click="onClickRight" />
    </van-nav-bar>
    <van-popup v-model="show" position="bottom" round :style="{ height: '80%' }">
      <div>
        <div
          v-for="item in this.bList.subMenu"
          :key="item.ID"
          class="down-name van-hairline--bottom"
        >
          <div @click="menuBtn(item)">{{ item.Name }}</div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="navShow" position="bottom" round :style="{ height: '15%' }">
      <div class="nav-btm">
        <div class="nav-btm-content" @click="goHome">
          <div class="nav-btm-icon">
            <img src="../../../../../assets/common/home.png" class="nav-icons" />
          </div>
          <div class="nav-btm-name">首页</div>
        </div>
        <div class="nav-btm-content" @click="goModule">
          <div class="nav-btm-icon">
            <img src="../../../../../assets/common/m-module.png" class="nav-icons" />
          </div>
          <div class="nav-btm-name">功能导航</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "headnav",
  data() {
    return {
      show: false,
      navShow: false,
      isBreadcrumbIcon: false,
      isMsg: false,
      bList: {},
      titleName: ""
    };
  },
  computed: {
    style_isTransparent() {
      return this.$store.state.globalNavBar_transparentMode;
    }
  },
  mounted() {
    if (this.$route.query.fromMessage) {
      this.isMsg = true;
      // 从消息页面跳转
      this.titleName = JSON.parse(this.$store.state.messageInfo).MessageTypeName;
    } else {
      // 从列表跳转
      this.isMsg = false;
      if (this.$route.path === "/funclist") {
        localStorage.setItem("navTitle", "智慧校园");
        this.isBreadcrumbIcon = false;
      } else {
        this.bList = JSON.parse(localStorage.getItem("breadcrumb"));
        if (this.bList.subMenu.length > 0) {
          this.isBreadcrumbIcon = true;
        } else {
          localStorage.setItem("navTitle", this.bList.Name);
          this.isBreadcrumbIcon = false;
        }
      }
      this.titleName = localStorage.getItem("navTitle");
    }
  },
  watch: {
    '$route': {
      handler(val) {
        if (val.name === "funclist") {
          localStorage.setItem("navTitle", "智慧校园");
          this.isBreadcrumbIcon = false;
          this.isMsg = false;
        } else {
          this.bList = JSON.parse(localStorage.getItem("breadcrumb"));
          if (this.bList.subMenu.length > 0) {
            this.isBreadcrumbIcon = true;
            this.isMsg = true;
            for (let i = 0, len = this.bList.subMenu.length; i < len; i++) {
              if (this.bList.subMenu[i].ApplicationSubMenuMobileUrl === val.path) {
                localStorage.setItem("navTitle", this.bList.subMenu[i].Name);
              }
            }
          } else {
            localStorage.setItem("navTitle", this.bList.Name);
            this.isBreadcrumbIcon = false;
            this.isMsg = false;
          }
        }
        this.titleName = localStorage.getItem("navTitle");
      },
      deep: true,
      immediate:true
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.navShow = true;
    },
    showTopBtn() {
      this.show = true;
    },
    menuBtn(vals) {
      this.show = false;
      this.$router.replace(vals.ApplicationSubMenuMobileUrl + "?" + new Date().getTime());
      this.titleName = vals.Name;
      this.$store.commit("common/getMenuIDs", [vals.ApplicationID, vals.ID]);
    },
    goHome() {
      this.navShow = false;
      this.$router.replace("/xyIndex");
    },
    goModule() {
      this.navShow = false;
      if (this.$route.name !== "funclist") {
        this.$router.replace("/funclist");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.icon-title-size{
  font-size: 38px;
}
.icon-left {
  margin-left: 12px;
}
.down-name {
  text-align: center;
  height: 100px;
  line-height: 100px;
  // .1px();
}
.nav-menu-stlye {
  margin-left: 16px;
}
.nav-btm {
  height: 100%;
  display: flex;
  align-items: center;
  .nav-btm-content {
    width: 24%;
    text-align: center;
    .nav-btm-icon {
      width: 90px;
      height: 90px;
      display: flex;
      align-items: center;
      margin: 0 auto 16px;
      .nav-icons {
        display: block;
        width: 100%;
        height: 100%;
        margin: 0 auto;
      }
    }
    .nav-btm-name {
      font-size: 22px;
    }
  }
}

::v-deep .xy-navBar--isTransparent {
  /* 头部背景设置：将Vant的导航栏设置为透明背景 */
  .van-nav-bar__title {
    color: #fff;
  }
  &.van-nav-bar--fixed.van-hairline--bottom {
    background-color: transparent;
    .van-nav-bar:after {
      content: none;
    }
  }
  .van-icon.van-icon-arrow-left {
    color: #fff !important;
  }
  &.van-hairline--bottom:after {
    border-bottom-width: 0;
  }
}
</style>
